module.exports = __webpack_public_path__ + "static/img/logo3.e5a2bee.png";


//////////////////
// WEBPACK FOOTER
// ./static/ios/logo3.png
// module id = GHs7
// module chunks = 0